import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pharmacies',
  templateUrl: './pharmacies.component.html',
  styleUrls: ['./pharmacies.component.css']
})
export class PharmaciesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
